function r(e,n){return e=e||"",new RegExp("^(?:"+n+")$").test(e)}

export { r as default };
//# sourceMappingURL=contact-channels213.js.map
